<template>
      <carousel :items="items" :margin="margin" :loop="loop" :autoplay="autoplay"  :data="data"  :dots="dots">
          <div class="single-carousel-item" v-for="(item,i) in data" :key="i">
            <div class="banner-carousel-img">
              <img :src="item.img" alt="banner-logo">
            </div>
            <div class="banner-carousel-caption">
                <div class="container">
                  <h2>{{item.content.head}}</h2>
                  <p>{{item.content.para}}</p>
                  <router-link :to="item.content.link" class="btn banner-btn">{{item.content.btn}}</router-link>
                </div>
            </div>
          </div>
      </carousel>
</template>

<script>

  import carousel from 'vue-owl-carousel'

  export default {
    components: { carousel },
    props: {
      data: {
        type : Array,
        default: () => []
      },
      items: {
        type: Number
      },
      margin: {
        type: Number
      },
      loop: {
        type : Boolean
      },
      autoplay: {
        type : Boolean
      },
      dots : {
        type: Boolean,
        default: true
      }
    }
  }
</script>
